import { Singleton } from 'annotation';
import environment from 'environment';

import ProxyService from './Proxy';

import EntityAware from '../entity/EntityAware';
import Santri from "../entity/Santri";
import Parameter from "./Parameter";
import BulkPengajianRequest from "../entity/BulkPengajianRequest";
import { Serialize } from "cerialize";
import BulkSekolahRequest from "../entity/BulkSekolahRequest";
import ValidasiPendaftar from "../entity/ValidasiPendaftar";

@Singleton
export default class SantriService extends ProxyService {

    public api: string = environment.SANTRI_API;   // define api url to fetch data

    public serializer: EntityAware = Santri;

    public serializerBulkPengajian: EntityAware = BulkPengajianRequest;

    public serializerBulkSekolah: EntityAware = BulkSekolahRequest;

    public serializerValidasiPendaftar: EntityAware = ValidasiPendaftar;

    public findSantriById(id: string): Promise<any> {
        const parameter = new Parameter()
            .setUrl(this.api + `/${id}`).serializeData(this.serializer);
        return super.request(parameter);
    }

    public downloadTemplate() {
        const api: string = this.api + '/template';
        const fileName = `Template Upload Santri.xlsx`;

        return super.downloadFile(api, fileName, false);
    }

    public updateSantri(T: Santri, id: string): Promise<any> {
        const data: FormData = new FormData();
        data.append('santri', JSON.stringify(Serialize(T)));
        data.append('file', T.file);

        const parameter = new Parameter(data).setMethod(Parameter.methods.PUT)
            .setUrl(`${this.api}?id=${id}`);

        return this.request(parameter);
    }

    public updateBulkPengajian(param: BulkPengajianRequest): Promise<any> {
        let parameter: Parameter;
        if (param.file) {
            const data: FormData = new FormData();
            data.append('file', param.file);
            data.append('from_pengajian', param.from_pengajian);
            data.append('to_pengajian', param.to_pengajian);
            parameter = new Parameter(data).setMethod(Parameter.methods.POST)
                .setUrl(`${this.api}/pengajian`);
        } else {
            parameter = new Parameter(param).setMethod(Parameter.methods.POST)
                .setUrl(`${this.api}/pengajian`).serializeData(this.serializerBulkPengajian);
        }

        return this.request(parameter);
    }

    public updateBulkSekolah(param: BulkSekolahRequest): Promise<any> {
        let parameter: Parameter;
        if (param.file) {
            const data: FormData = new FormData();
            data.append('file', param.file);
            data.append('from_tingkat', param.from_tingkat);
            data.append('from_kelas', param.from_kelas);
            data.append('to_tingkat', param.to_tingkat);
            data.append('to_kelas', param.to_kelas);
            data.append('sekolah', param.sekolah);
            parameter = new Parameter(data).setMethod(Parameter.methods.POST)
                .setUrl(`${this.api}/sekolah`);
        } else {
            parameter = new Parameter(param).setMethod(Parameter.methods.POST)
                .setUrl(`${this.api}/sekolah`).serializeData(this.serializerBulkSekolah);
        }

        return this.request(parameter);
    }

    public uploadSantri(file: any) {
        const param: FormData = new FormData();
        const api = this.api + '/upload';

        param.append('file', file);

        const parameter: Parameter = new Parameter(param).setUrl(api).setMethod(Parameter.methods.POST).setEnableNotif(false);

        return super.request(parameter);
    }

  public downloadTemplateKenaikanKelas(pengajian: string, tingkat: string, kelas: string) {
    const api: string = this.api + `/update/template?pengajian=${pengajian}&tingkat=${tingkat}&kelas=${kelas}`;
    const fileName = `Template Update Data Santri.xlsx`;

    return super.downloadFile(api, fileName, false);
  }

    public downloadUpdateTemplate(komplek: string, pengajian: string, tingkat: string, kelas: string, kelamin: string) {
        const api: string = this.api + `/bulk-update/template?komplek=${komplek}&pengajian=${pengajian}&tingkat=${tingkat}&kelas=${kelas}&kelamin=${kelamin}`;
        const fileName = `Template Update Data Santri.xlsx`;

        return super.downloadFile(api, fileName, false);
    }

    public uploadBulkUpdate(file: any) {
        const param: FormData = new FormData();
        const api = this.api + '/bulk-update/upload';

        param.append('file', file);

        const parameter: Parameter = new Parameter(param).setUrl(api).setMethod(Parameter.methods.POST).setEnableNotif(false);

        return super.request(parameter);
    }

    public findValidasiPendaftar(nomor: string, nama: string): Promise<any> {
        const parameter = new Parameter().setUrl(this.api + `/validasi?nomor=${nomor}&nama=${nama}`).serializeData(this.serializerValidasiPendaftar);
        return this.request(parameter);
    }

    public saveValidasiPendaftar(param: any): Promise<any> {
        const api: string = this.api + `/validasi`;
        return this.request(new Parameter(param).setMethod(Parameter.methods.POST).setUrl(api));
    }

}
